import React from 'react'

const Header = () => {
    return (
        <div>
            <script src="/assets/js/jquery-3.3.1.min.js"></script>
            <script src="/assets/js/bootstrap.min.js"></script>
            <script src="/assets/js/scripts.js"></script>
            {/* start header section */}
            <header className="header">
                {/* start navbar */}
                <div className="navbar navbar-default navbar-fixed-top">
                    <div className="container">
                        <div className="row">
                            <div className="navbar-header page-scroll">
                                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse"
                                        data-target="#myNavbar" style={{
                                    marginTop: "25px",
                                    backgroundColor: "transparent",
                                }}>
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar" style={{backgroundColor: "#FFF"}}></span>
                                    <span className="icon-bar" style={{backgroundColor: "#FFF"}}></span>
                                    <span className="icon-bar" style={{backgroundColor: "#FFF"}}></span>
                                </button>
                                <a className="navbar-brand page-scroll" href="/">
                                    <img src={"/logo-white.png"} alt="logo" style={{height: "60px"}}/>
                                </a>
                            </div>


                            <div className="navbar-collapse collapse" id="myNavbar">
                                <ul className="nav navbar-nav navbar-right" style={{margin: "12px 0"}}>
                                    <li className="active"><a style={{backgroundColor:"transparent",color:"#FFF"}} href="/export-cerfas">Mes Reçus Fiscaux</a></li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
                {/* end navbar */}
            </header>
            {/* end header section */}
        </div>
    )
}


export default Header;
